import moment from 'moment-timezone';
/**
 * Generates an array of localized time strings in 15 minute intervals.
 *
 * @example ['12:00 am', '12:15am', ... '11:45 pm']
 * @returns {array}
 */
export default function generateTimeIntervalArray(localeTime, intervalInMinutes = 15) {
  const options = [];
  const currentMoment = moment();
  for (let hour = 0; hour <= 23; hour += 1) {
    for (let minute = 0; minute <= 59; minute += intervalInMinutes) {
      currentMoment.set('hour', hour);
      currentMoment.set('minute', minute);
      options.push(localeTime.dateTime(currentMoment, 'shortTime'));
    }
  }
  return options;
}